export const APIURL = "https://api-demo.easylab.tn";

export const maxRowsTableWorks: number = 10;

export const getPages = (rows: number) => {
  return Math.ceil(rows / maxRowsTableWorks);
};
